export default __webpack_public_path__ + "static/media/html_css.d2438b53.jpg";